import React from 'react';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import useStyles from './styles';

const InfoCardViewer = (props) => {
  const { config, blockState } = props;
  const classes = useStyles();

  const checkConditions = (conditions, state) => {
    // 1. No conditions → always render
    if (!conditions || conditions.length === 0) return { shouldRender: true, missingKey: false };

    let result = null;
    let missingKey = false;

    for (const cond of conditions) {
      const fieldValue = state?.[cond.selectedConditionDataElement];

      // If the key is not present
      if (fieldValue === undefined || fieldValue === null) {
        missingKey = true;
        continue;
      }

      let isMet = false;
      switch (cond.selectedConditionOperator) {
        case 'is_equals':
          isMet = fieldValue === cond.value;
          break;
        case 'is_not_equals':
          isMet = fieldValue !== cond.value;
          break;
        case 'contains':
          isMet = Array.isArray(fieldValue) && fieldValue.includes(cond.value);
          break;
        case 'not_contains':
          isMet = Array.isArray(fieldValue) && !fieldValue.includes(cond.value);
          break;
        default:
          isMet = true;
      }

      if (cond.selectedConditionClause === 'or') {
        result = result === null ? isMet : result || isMet;
      } else if (cond.selectedConditionClause === 'and') {
        result = result === null ? isMet : result && isMet;
      }
    }

    if (result === null) return { shouldRender: false, missingKey };
    return { shouldRender: result, missingKey };
  };

  return (
    <div className={classes.root}>
      {config.map((card, index) => {
        const { shouldRender, missingKey } = checkConditions(card.conditions, blockState);
        if (!shouldRender) return null;

        const value = missingKey ? '-' : (blockState?.[card.value] ?? '-');

        return (
          <div key={index} className={classes.card}>
            <div className={classes.iconBox}>
              <img src={card.icon} className={classes.iconImg} alt="" />
            </div>

            <div className={classes.textCol}>
              <Tooltip title={card.label || ''} placement="top" arrow>
                <Typography className={classes.label}>{card.label}</Typography>
              </Tooltip>

              <Tooltip title={`${value}`} placement="top" arrow>
                <Typography className={classes.value}>{value}</Typography>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InfoCardViewer;
